import { render, staticRenderFns } from "./OurClients.vue?vue&type=template&id=4703ed77&scoped=true&"
var script = {}
import style0 from "./OurClients.vue?vue&type=style&index=0&id=4703ed77&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4703ed77",
  null
  
)

export default component.exports